// extracted by mini-css-extract-plugin
module.exports = {"account-data":"addPost_account-data__pBdpj"};